import React from 'react';
import * as styles from './ReferralModal.module.scss';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import Button from '../components/Button';
import Form, { Field } from '../components/Form';
import Modal, { ModalTitle } from '../components/Modal';
import { ACTION_REFERRAL_COPY, CATEGORY_GROWTH } from '../constants/analytics';
import { UIActions } from '../ui/uiSlice';
import { track } from '../utils/analytics';
import Link from '../utils/router/Link';

interface ReferralModalProps {
  close: () => void;
}

const ReferralModal = ({ close }: ReferralModalProps) => {
  const user = useAppSelector((state) => state.session.user);
  const dispatch = useAppDispatch();

  const link = `slab.com/r/${user.id}`;

  const onClick = async () => {
    track(ACTION_REFERRAL_COPY, { category: CATEGORY_GROWTH });
    await navigator.clipboard.writeText(`https://${link}`);
    dispatch(
      UIActions.pushToast({
        level: 'success',
        message: 'Shareable link copied',
      }),
    );
  };

  return (
    <Modal width={500}>
      <ModalTitle noMargin close={close}>
        Get up to $200 for every friend you refer to Slab!
      </ModalTitle>
      <div className={styles.description}>
        Share the link below and get up to $200 in Amazon gift cards per
        referral! Your friend will also get 20% off their first 3 months.{' '}
        <Link to="https://go.slab.com/referral-program" newTab>
          Learn more
        </Link>
      </div>
      <Form initialValues={{ link }}>
        <div className={styles.field}>
          <Field margin="none" name="link" readOnly label="Shareable link" />
          <Button variant="primary" onClick={onClick}>
            Copy
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ReferralModal;
